import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OauthComponent} from './oauth/oauth.component';
import {TranslateModule} from "@ngx-translate/core";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {GlobalLoadingComponent} from "./loading/global-loading/global-loading.component";
import {StepperComponent} from './stepper/stepper.component';
import {HekaNavigationContainerComponent, NgxHekaDesignLibModule} from "ngx-heka-design-lib";
import {MatMenuModule} from "@angular/material/menu";
import {MatTabsModule} from "@angular/material/tabs";
import {RouterModule} from "@angular/router";
import {
  L2ChangeTableColumnsButtonComponent
} from "./l2-change-table-columns-button/l2-change-table-columns-button.component";
import {AssignedApplicationListComponent} from "./assigned-application-list/assigned-application-list.component";
import {NoAppAccessComponent} from "./no-app-permission/no-app-access.component";
import {MatFormFieldModule} from "@angular/material/form-field";
import {L2MinimalMenuBarComponent} from "./l2-minimal-menu-bar/l2-minimal-menu-bar.component";
import {AppTranslationKeysPipe} from "../pipes/app-translation-keys.pipe";
import {HekaApplicationImgComponent} from "ngx-heka-design-lib"


@NgModule({
  declarations: [
    OauthComponent,
    GlobalLoadingComponent,
    StepperComponent,
    L2ChangeTableColumnsButtonComponent,
    AssignedApplicationListComponent,
    NoAppAccessComponent,
    L2MinimalMenuBarComponent,
  ],
  exports: [
    StepperComponent,
    L2ChangeTableColumnsButtonComponent,
    AssignedApplicationListComponent,
    L2MinimalMenuBarComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    NgxHekaDesignLibModule,
    MatMenuModule,
    MatTabsModule,
    RouterModule,
    MatFormFieldModule,
    AppTranslationKeysPipe,
    HekaNavigationContainerComponent,
    HekaApplicationImgComponent
  ]
})
export class ComponentsModule {
}
